/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 16:49:12
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface TAHManagementListParams {
  recordDateStart?: any
  recordDateEnd?: any
  recordUserName?:any
  current?: any
  size?: any
}

export function getTAHManagementList(
  params: TAHManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumidity/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getTAHManagementDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumidity/detail`,
    method: 'GET',
    params
  }
}


// 保存编辑
export interface SubmitParams {
  id?: any
  local?: any
  localId?: any
  temperature?: any
  humidity?:any
  measure?: any
  temperatureAfterMeasures?: any
  humidityAfterMeasure?: any
  recordDate?: any
  remark?: any
}

export function getTAHManagementSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumidity/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumidity/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
